const SITE = 'https://crhome.mx';

export const SEO_BY_PATH = {
  '/': {
    title: 'Arquitectura e interiorismo en Playa del Carmen | CR Home',
    description: 'Estudio de interiorismo, arquitectura y remodelación en Playa del Carmen, Tulum y Cancún. Residencias, condos y hoteles de lujo. Agenda tu diagnóstico.',
    ogTitle: 'CR Home | Interiorismo y arquitectura en Playa del Carmen',
    ogDescription: 'Estudio de interiorismo, arquitectura y remodelación en Playa del Carmen, Tulum y Cancún.'
  },
  '/nosotros': {
    title: 'Carolina Riestra y el estudio CR Home | Playa del Carmen',
    description: 'Conoce a Carolina Riestra, directora creativa de CR Home, y a su estudio de interiorismo y arquitectura residencial en Playa del Carmen y la Riviera Maya.'
  },
  '/proyectos': {
    title: 'Proyectos de interiorismo en la Riviera Maya | CR Home',
    description: 'Portafolio de CR Home: residencias, condos y espacios de lujo en Playa del Carmen, Puerto Aventuras y la Riviera Maya. Conoce cada proyecto en detalle.'
  },
  '/blog': {
    title: 'Blog de interiorismo, arquitectura y remodelación | CR Home',
    description: 'Guías de remodelación, acabados, mobiliario a medida y arquitectura residencial, escritas desde Playa del Carmen por el estudio CR Home.'
  },
  '/contacto': {
    title: 'Contacto | CR Home, interiorismo en Playa del Carmen',
    description: 'Escríbenos por WhatsApp al +52 984 179 3706 o a admin@crhome.mx. Atendemos proyectos en Playa del Carmen, Tulum, Cancún y la Riviera Maya.'
  },
  '/politica-de-reembolso': {
    title: 'Política de reembolso | CR Home',
    description: 'Política de reembolso, cambios, devoluciones y garantías de las compras realizadas en shop.crhome.mx, tienda operada por CR Home.'
  },
  '/agenda': {
    title: 'Agenda tu diagnóstico de interiorismo | CR Home',
    description: 'Reserva en línea tu diagnóstico de interiorismo con CR Home para tu residencia, condo o proyecto comercial en Playa del Carmen, Tulum o Cancún.'
  }
};

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(attr, key) {
  const el = document.querySelector(`meta[${attr}="${key}"]`);
  if (el) el.remove();
}

export function applySeo(path) {
  const isInternal = path.startsWith('/os') || path === '/respuesta';
  const seo = SEO_BY_PATH[path];
  const notFound = !seo && !isInternal;
  const title = isInternal ? 'CR Home' : notFound ? 'Página no encontrada | CR Home' : seo.title;
  const description = seo?.description || '';

  document.title = title;
  setMeta('name', 'description', description);

  const url = SITE + (path === '/' ? '/' : path);
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', url);

  setMeta('property', 'og:type', 'website');
  setMeta('property', 'og:locale', 'es_MX');
  setMeta('property', 'og:site_name', 'CR Home');
  setMeta('property', 'og:url', url);
  setMeta('property', 'og:title', seo?.ogTitle || title);
  setMeta('property', 'og:description', seo?.ogDescription || description);
  setMeta('property', 'og:image', `${SITE}/images/hero/hero-1.webp`);
  setMeta('name', 'twitter:card', 'summary_large_image');
  setMeta('name', 'twitter:title', seo?.ogTitle || title);
  setMeta('name', 'twitter:description', seo?.ogDescription || description);
  setMeta('name', 'twitter:image', `${SITE}/images/hero/hero-1.webp`);

  if (isInternal) setMeta('name', 'robots', 'noindex, nofollow');
  else if (notFound) setMeta('name', 'robots', 'noindex');
  else removeMeta('name', 'robots');
}

export const setSeo = applySeo;
